import { memo, useMemo } from 'react';
import { LOCATIONS, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { BzChip } from '../../components';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
//Vaibhav Singh: 06-03-24: Pagecalled variable added as we are not showing name of exchange: Start
function WatchlistSymbolColumn({ arrRowData, isScrenners = false, value, pageCalled, ...props }) {

    const { holdingsScrips } = useSelector(state => state.holdings);

    const { pathname } = useLocation();
    const isLocationDahsboard = useMemo(() => {
        if (pathname === LOCATIONS.WATCHLIST && isScrenners) {
            return true;
        } else {
            return false;
        }
    }, [pathname, isScrenners])

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const WatchlistGridPopoverName = ({ arrRowData }) => {
        if (arrRowData?.length > 0) {
            if ((arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
                return (<div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext" : "font-regular font-enlarge color-subtext"}`}>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
            } else if (!arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                !arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
                return (<div className='d-flex align-items-center'>
                    <div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext" : "font-regular font-enlarge color-subtext"}`}>{arrRowData[WATCHLIST_GRID_INDEX.SERIES]}</div>
                </div>);
            }
            else if (arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
                return (
                    <div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext" : "font-regular font-enlarge color-subtext"}`}>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
                );
            }
            else {
                return null;
            }
        } else {
            return null;
        }
    };
    // Ameersha N | BT-95888 Create Watchlist Feature end
    ;
    return (
        <div className='scrip-wrap'>
            {
                arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && Object?.keys(arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS][0])?.includes('event') &&
                <div className='normal-scrip dontmiss-scrip'></div>
            }
            <div className='d-flex justify-content-start align-items-center'>
                <div className={`${isLocationDahsboard ? "font-medium font-size1 color-text text-uppercase ms-2 me-2" : "font-medium font-enlarge color-text text-uppercase ms-2 me-2"}`} >{value}</div>  {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
                {(pageCalled) ? (arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]) ? <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                </div> : null : <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                </div>}
                <WatchlistGridPopoverName arrRowData={arrRowData} />
                {
                    arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && Object?.keys(arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS][0])?.includes('event') &&
                    <div className='icon-16 icon-dontmiss icon-yellow ms-2'></div>
                }
                {/* Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: Start */}
                {holdingsScrips?.length > 0 && holdingsScrips?.some(element => element?.TOTALFREEQUANTITY !== "0" && element?.ISIN === arrRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] && arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) &&
                    <div className='icon-16 icon-portfolio icon-dark ms-2'></div>
                }
                {/* Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: End */}
            </div>

        </div>
    );
}
//Vaibhav Singh: 06-03-24: Pagecalled variable added as we are not showing name of exchange: 
export default memo(WatchlistSymbolColumn);